// 数据来源（dataFrom）取值：用于判断字段数据来源是否为 iservice
export const __DATA_FROM_ISERVICE__ = 'iservice';

// 接口 sourceType 参数取值
export const __SOURCE_TYPE_WEB_SITE__ = 'Web Site';

// 服务请求类型：细分服务类型需统一转换为该值传给接口
export const __SERVICE_TYPE_SERVICE_REQUEST__ = 'Service Request';

// 属于服务细分类型的 serviceType，命中时原值需通过 serviceSubType 传出
export const SERVICE_SUB_TYPES = ['Inspection', 'Installation', 'Repair', 'Inquiry', 'Complaint'];
